import React, { useContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

import { authActions } from '@/store/actions/auth.actions';
import api from '@/services/api';

import video1 from '@/assets/videos/simplifying/Upraszczanie 1.mp4';
import video2 from '@/assets/videos/simplifying/Upraszczanie 2.mp4';
import video3 from '@/assets/videos/simplifying/Upraszczanie 3.mp4';
import video4 from '@/assets/videos/simplifying/Upraszczanie 4.mp4';
import video5 from '@/assets/videos/simplifying/Upraszczanie 5.mp4';

import styles from '@/views/components/Modal/Simplification/ModalSimplification.module.scss';

const ModalSimplification = () => {
	const dispatch = useDispatch();

	const { dict, langNormalization } = useSelector((state) => state.app);
	const user = useSelector(state => state.auth.user);

	const { closeModal } = useContext(ModalContext);

	const [ page, setPage ] = useState(0);

	const finishIntroduction = () => {
		api.put(`/users/simplifying-guide/${user.id}/false`).then(() => {
			api.get('/auth/me').then((response) => {
				dispatch(authActions.setUser(response.data));
				closeModal();
			});
		});
	};

	return (
		<div className='modal__content'>
			<div className={ styles['modal-simplification__wrapper'] }>
				<div className={ styles['modal-simplification__top'] }>
					<div className={ styles['modal-simplification__top--header'] }>
						{page === 0 && dict.modals.simplifying.page0.header}
						{page === 1 && dict.modals.simplifying.page1.header}
						{page === 2 && dict.modals.simplifying.page2.header}
						{page === 3 && dict.modals.simplifying.page3.header}
						{page === 4 && dict.modals.simplifying.page4.header}
						{page === 5 && dict.modals.simplifying.page5.header}
					</div>
					<div 
						className={ styles['modal-simplification__top--skip'] }
						onClick={ finishIntroduction }
					>
						{dict.modals.simplifying.skip}
					</div>
				</div>
				<div className={ styles['modal-simplification__content'] }>
					{page === 0 && <>
						<p className={ styles['modal-simplification__content__first-page--text'] }>
							{dict.modals.simplifying.page0.text}
						</p>
						<div className={ styles['modal-simplification__content__first-page__background'] } />
					</>}

					{page === 1 && <>
						<p>
							<strong>{dict.modals.simplifying.page1.text.part1}</strong> {dict.modals.simplifying.page1.text.part2}
						</p>
						<p>
							<strong>{dict.modals.simplifying.page1.text.part3}</strong> {dict.modals.simplifying.page1.text.part4}
						</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video1 }
							/>
						</video>
					</>}

					{page === 2 && <>
						<p>
							{dict.modals.simplifying.page2.text.part1}
						</p>
						<ol>
							<li>{dict.modals.simplifying.page2.list.part1}</li>
							<li>{dict.modals.simplifying.page2.list.part2}</li>
							<li>{dict.modals.simplifying.page2.list.part3}</li>
						</ol>
						<p>
							<strong>{dict.modals.simplifying.page2.text.part2}</strong>
						</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video2 }
							/>
						</video>
					</>}

					{page === 3 && <>
						<p>
							{dict.modals.simplifying.page3.text.part1}
						</p>
						{ langNormalization && <p>
							{ dict.modals.simplifying.page3.text.optionalPartA }
						</p> }
						<p>
							<strong>{dict.modals.simplifying.page3.text.part2}</strong>
						</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video3 }
							/>
						</video>
					</>}

					{page === 4 && <>
						<p>{dict.modals.simplifying.page4.text.part1}</p>
						<ol>
							<li>{dict.modals.simplifying.page4.list.part1}</li>
							<li>{dict.modals.simplifying.page4.list.part2}</li>
						</ol>
						<p><strong>{dict.modals.simplifying.page4.text.part2}</strong> {dict.modals.simplifying.page4.text.part3}</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video4 }
							/>
						</video>
					</>}

					{page === 5 && <>
						<p>{dict.modals.simplifying.page5.text.part1}</p>
						<p>{dict.modals.simplifying.page5.text.part2}</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video5 }
							/>
						</video>
					</>}
				</div>
				<div className={ styles['modal-simplification__bottom'] }>
					{page === 0 && <>
						<button 
							className='button__blue'
							style={ { marginLeft: 'auto', gridColumnStart: 3 } }
							onClick={ () => { setPage(1); } }
						>
							{dict.modals.simplifying.page0.button}
							<i className='icon-arrow-right-full' />
						</button>
					</>}
					{page > 0 && <>
						<button 
							className='button__white'
							onClick={ () => { setPage(page - 1); } }
						>
							<i className='icon-arrow-left-full' />
							{dict.modals.simplifying.previous}
						</button>
						<div style={ { textAlign: "center" } }>
							{page} z 5
						</div>
						{(page === 1 || page === 2 || page === 3 || page === 4) &&
							<button 
								className='button__blue'
								onClick={ () => { setPage(page + 1); } }
								style={ { marginLeft: 'auto' } }
							>
								{dict.modals.simplifying.next}
								<i className='icon-arrow-right-full' />
							</button>}
						{(page > 4) &&
							<button 
								className='button__blue'
								onClick={ finishIntroduction }
								style={ { marginLeft: 'auto' } }
							>
								{dict.modals.simplifying.page5.button}
							</button>}
					</>}
				</div>
			</div>
		</div>
	);
};

export default ModalSimplification;